(() => {
  const selector = '#CollectionProductGrid [data-tc-collection-results]';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const results = doc => doc.querySelector(selector);
  const cards = node => Array.from(node.querySelectorAll('.collection-products > div > article.collection-product'));
  const fetchResults = async url => {
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Collection request failed');
    const node = results(parse(await response.text()));
    if (!node || Number(node.dataset.pageSize) !== 250) throw new Error('Collection inventory missing');
    return node;
  };
  const prepare = async (html, requestURL) => {
    const doc = parse(html), target = results(doc);
    if (!target || target.dataset.pageSize === '250') return html;
    const url = new URL(requestURL, location.origin);
    const size = Number(target.dataset.pageSize), page = Number(target.dataset.page);
    const total = Number(target.dataset.count);
    if (!total) return html;
    url.searchParams.delete('section_id');
    url.searchParams.set('view', 'inventory');
    url.searchParams.set('page', '1');
    const batches = [await fetchResults(url)];
    const count = Math.ceil(total / 250);
    if (count > 100) throw new Error('Collection exceeds pagination limit');
    let next = 2;
    await Promise.all(Array.from({length: Math.min(4, count - 1)}, async () => {
      while (next <= count) {
        const batchPage = next++;
        const batchURL = new URL(url);
        batchURL.searchParams.set('page', String(batchPage));
        batches[batchPage - 1] = await fetchResults(batchURL);
      }
    }));
    if (batches.some(batch => Number(batch.dataset.count) !== total)) throw new Error('Collection changed; refresh required');
    const all = batches.flatMap(cards);
    if (all.length !== total || new Set(all.map(card => card.id)).size !== total) throw new Error('Incomplete collection');
    all.sort((a, b) => Number(a.dataset.available !== 'true') - Number(b.dataset.available !== 'true'));
    const offset = (page - 1) * size;
    const chosen = all.slice(offset, offset + size);
    const grid = target.querySelector('.collection-products > div:not(.loading-overlay)');
    if (!grid) throw new Error('Collection grid missing');
    grid.replaceChildren(...chosen.map(card => doc.importNode(card, true)));
    target.dataset.inventorySorted = 'true';
    return doc.documentElement.outerHTML;
  };
  window.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('#CollectionProductGrid .pagination a[href]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);
  window.TCCollectionInventory = { prepare };
  const initial = async () => {
    const target = results(document);
    if (!target || target.dataset.pageSize === '250') return;
    target.setAttribute('aria-busy', 'true');
    target.classList.add('tc-collection-loading');
    try {
      const html = await prepare(document.documentElement.outerHTML, location.href);
      if (!target.isConnected) return;
      const replacement = results(parse(html));
      target.innerHTML = replacement.innerHTML;
      target.dataset.inventorySorted = 'true';
    } catch (error) {
      console.warn('Collection inventory ordering unavailable', error);
    } finally {
      target.removeAttribute('aria-busy');
      target.classList.remove('tc-collection-loading');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initial, { once: true });
  else initial();
})();
